//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'uploadUnit',
  props: {
    bgIndex: [Number, String],
    value: [String, Number, Boolean, null],
    uploaderInstance: Object,
    uploadToken: String,
    code: String,
    isUpdateStatus: Boolean,
    historyImgObj: [Object, null],
  },
  watch: {
    historyImgObj(newVal) {
      const historyImgObj = newVal
      // 如果历史影像为空，则无需回显，直接return
      if (!historyImgObj) return

      const currentCode = this.code // 当前uploadUnit的code（如S001_0705_LF45）
      const currentBgIndex = this.bgIndex

      // 分支1：处理验车照片（code以S001_0705_开头）
      if (currentCode.startsWith('S001_0705_')) {
        // 从父组件的historyImgObj中，获取归类好的所有验车照片列表
        const allCheckImgs = historyImgObj['S001_0705'] || []
        if (!allCheckImgs.length) return

        // 匹配当前三级code对应的照片（如currentCode=S001_0705_LF45，找realCode一致的）
        const targetImg = allCheckImgs.find(img => img.realCode === currentCode)
        if (targetImg) {
          this.imageStr = targetImg.imgUrl // 回显图片
          this.imgId = targetImg.imgId     // 存储图片ID（用于删除）
          this.$emit('input', targetImg.imgUrl) // 同步v-model值到父组件
        }
        return
      }

      // 分支2：处理其他照片（身份证、驾驶证等，保持原有逻辑）
      // 如果历史影像不存在当前目录，则无需回显，直接return    如果历史影像当前目录没有值，则无需回显，直接return
      if (!historyImgObj[currentCode] || !historyImgObj[currentCode].length) return
      const fn = this.feedbackImg
      switch (currentBgIndex) {
        case '01': fn(historyImgObj, 0); break // 身份证正面
        case '02': fn(historyImgObj, 1); break // 身份证反面
        case '03': fn(historyImgObj, 0); break // 驾照正面
        case '04': fn(historyImgObj, 1); break // 驾照反面
        case '11': fn(historyImgObj, 0); break // 营业执照
        case '00': this.imageArr = historyImgObj[currentCode]; break // 地标合照
        default: break
      }
    },
    imageStr() {
      this.$emit('changeImage')
    }
  },
  mounted() {},
  data() {
    return {
      imageStr: '',
      tempValue: this.value,
      imgId: '',
      imageArr: [],
    }
  },
  methods: {
    // 回显影像
    feedbackImg(historyImgObj, index) {
      const code = this.code
      // 安全取值：若索引超出数组长度，默认空值
      const targetImg = historyImgObj[code][index] || {}
      this.imageStr = targetImg.imgUrl || ''
      this.imgId = targetImg.imgId || ''
      this.$emit('input', this.imageStr) // 同步v-model到父组件
    },
    // 上传图片
    uploadImg(files, imgId, e) {
      const arr = this.imageArr
      const vm = this
      files.forEach((file, idx) => {
        // 压缩率
        let quality = 0
        // 目录code
        const code = this.code
        // 插件实例对象
        const uploaderInstance = this.uploaderInstance
        if (file.size > 1 * 1024 * 1024) {
          quality = 0.9
        }
        uploaderInstance.fileSelected(file, (result) => {
          result.uploadNode = '投保补传' //设置上传环节
          uploaderInstance.upload({
            file: result.file,
            quality: quality || 1,
            pathData: {
              // 最末级的目录代码 可以使用管理员账号 登录管理系统 > 左边菜单 业务管理 > 业务模型中查看 > 找到相应目录然后查看【单证代码】
              typeCode: code,
            },
            VoData: result,
            success: (res) => {
              // 上传成功
              if (vm.code !== 'S001_0199') {
                // 只能上传单张图片
                vm.imageStr = res.fileRealURL
                vm.imgId = res.imgId
              } else {
                // 可以上传多张图片
                if (imgId === undefined) {
                  // 新增
                  arr.push({
                    imgUrl: res.fileRealURL,
                    imgId: res.imgId,
                    name: res.fileOrgName,
                  })
                  this.imageArr = arr
                  // 点击+上传可以重复上传同一张图片
                  if (idx === files.length - 1) {
                    e.target.value = ''
                  }
                } else {
                  // 编辑，编辑会传一个imgId，根据imgId找到index
                  const index = this.imageArr.findIndex(
                    (item) => item.imgId === imgId
                  )
                  index !== -1 &&
                    this.imageArr.splice(index, 1, {
                      imgUrl: res.fileRealURL,
                      imgId: res.imgId,
                      name: res.fileOrgName,
                    })
                }
              }
              // 上传多张也只调用一次更新状态接口
              if (!vm.isUpdateStatus && idx === 0) {
                vm.$emit('setImageUpdateStatus')
              }
            },
            error: (err) => {
              console.log(err)
              Toast(err.msg)
            },
          })
        })
      })
    },
    onSelect(e, imgId) {
      const files = e.target.files
      // 新增
      this.uploadImg(files, undefined, e)
      // let reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onload = function(e) {
      //     let imageStr = e.target.result;
      //     $http.haupload({
      //         query: {
      //             'x-ha-appname': 'gpurchase',
      //             'x-ha-appmodel': 'valicar_image',
      //         },
      //         data: {
      //             images: [imageStr.split(",")[1]]
      //         }
      //     })
      //     .then(res=>{
      //         if(res.errCode == '0'){
      //             vm.imageStr = imageStr;
      //             res = res.data[0];
      //             let realPath = res.domainPath + res.relativePath + res.newFileName;
      //             vm.tempValue = realPath;
      //             vm.$emit('input', vm.tempValue);
      //             vm.$emit('on-change', realPath);
      //         }else{
      //             return Promise.reject(res.errMsg);
      //         }
      //     })
      //     .catch(errMsg=>{
      //         Toast(errMsg);
      //     });
      // }
    },
    deleteImg(item) {
      let id, index
      if (item) {
        id = item.imgId
        index = this.imageArr.findIndex((img) => img.imgId === item.imgId)
      } else {
        id = this.imgId
      }
      // 删除图片
      this.uploaderInstance.deleteFile({
        imgIdList: [id],
        success: () => {
          // 删除成功
          if (item) {
            if (index !== -1) {
              this.imageArr.splice(index, 1)
            }
          } else {
            this.imageStr = ''
            this.imgId = ''
          }
        },
        error: (err) => {
          console.log(err)
          Toast('系统异常')
        },
      })
    },
  },
}
